var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"alt":_vm.alt,"src":_vm.placeholder,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }